import { reactLocalStorage } from 'reactjs-localstorage';
import MyService from '../../service';

const ModuleApi = {
  getOne: async (moduleId) => {
    const result = await MyService.getRequestData(`/module/${moduleId}`);
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  getAllModules: async () => {
    const result = await MyService.getRequestData('/module');
    if (result && result.data) {
      return result.data;
    }
    return [];
  },
  update: async (params) => {
    console.log('params', params);
    if (!params) return null;
    const result = await MyService.postRequestData(
      '/module/update',
      params
    ).catch((err) => console.log(err));
    return result;
  },
  create: async (data) => {
    const result = await MyService.postRequestData(
      '/module/create',
      data
    ).catch((err) => console.log(err));
    return result;
  },
};

export default ModuleApi;
